import { comparisonData } from '@/mocks/categories';

export default function ComparisonSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 leading-tight mb-3">
            Spreadsheet Comparison Hub
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            See how <strong>Kakobuy Spreadsheet</strong> stacks up against other popular
            spreadsheet platforms. Compare features, update frequency, and ease of use.
          </p>
        </div>

        <div className="overflow-x-auto rounded-2xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-primary-800">
                <th className="text-left px-5 py-4 text-background-50 font-medium">Feature</th>
                <th className="text-left px-5 py-4 text-accent-300 font-semibold">Kakobuy</th>
                <th className="text-left px-5 py-4 text-background-50/70 font-medium">CSSBuy</th>
                <th className="text-left px-5 py-4 text-background-50/70 font-medium">Superbuy</th>
                <th className="text-left px-5 py-4 text-background-50/70 font-medium">Oopbuy</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr
                  key={row.feature}
                  className={`${
                    idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100'
                  } hover:bg-accent-50/50 transition-colors`}
                >
                  <td className="px-5 py-3.5 text-foreground-700 font-medium">{row.feature}</td>
                  <td className="px-5 py-3.5 text-accent-600 font-semibold">{row.kakobuy}</td>
                  <td className="px-5 py-3.5 text-foreground-600">{row.cssbuy}</td>
                  <td className="px-5 py-3.5 text-foreground-600">{row.superbuy}</td>
                  <td className="px-5 py-3.5 text-foreground-600">{row.oopbuy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="text-xs text-foreground-500 hover:text-accent-600 transition-colors"
          >
            Explore Kakobuy Sheet
          </a>
          <span className="text-foreground-300">·</span>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="text-xs text-foreground-500 hover:text-accent-600 transition-colors"
          >
            CSSBuy Spreadsheet info
          </a>
          <span className="text-foreground-300">·</span>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="text-xs text-foreground-500 hover:text-accent-600 transition-colors"
          >
            Superbuy Spreadsheet info
          </a>
        </div>
      </div>
    </section>
  );
}